import { render, staticRenderFns } from "./srv-imgs.vue?vue&type=template&id=da3d7bc2&scoped=true&lang=pug&"
import script from "./srv-imgs.vue?vue&type=script&lang=js&"
export * from "./srv-imgs.vue?vue&type=script&lang=js&"
import style0 from "./srv-imgs.vue?vue&type=style&index=0&id=da3d7bc2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3d7bc2",
  null
  
)

export default component.exports